<template>
    <div class="timeline-container" @click="goToTime" ref="container">
        <vue-slider
                v-model="videoTime"
                :min="0"
                :max="videoDuration"
                :contained="true"
                :height="6"
                :drag-on-click="true"
                width="100%"
                :tooltip="'none'"
                :processStyle="{
                    background: skin.controls.color
                }"
                :dotStyle="{
                    background: skin.controls.color
                }"
                :railStyle="{
                    background: 'rgba(0, 0, 0, 0.4)'
                }"
                @change="playerSeek"
        ></vue-slider>
    </div>
</template>

<script>
    import {mapGetters, mapMutations} from 'vuex';
    import {EventBus} from '../../../lib/EventBus';
    export default {
        name: "Timeline",
        computed:{
            ...mapGetters([
                'videoDuration', 'currentTime', 'activeVideoId', 'skin'
            ]),

            videoTime: {
                set(time) {
                    this.updateCurrentTime(time)
                },
                get(){
                    return this.currentTime < this.videoDuration ? this.currentTime : this.videoDuration
                }
            },
            
            progress(){
                return (this.videoTime / this.videoDuration ) * 100;
            },
        },
        data:()=>({
            skipping:false
        }),
        methods:{

            ...mapMutations(['updateCurrentTime']),
            playerSeek(val){
                // this.$emit('goToTime', val);
                EventBus.$emit('skipTo', val);
            },
            goToTime(e){

                // This removes the css class that controls the transition so when skipping the video
                // the timeline doesn't slowly transition between current times.
                // this.skipping = true;
                // setTimeout(()=>{
                //     this.skipping = false
                // }, 500);

                const clickedPosition = e.x;
                const rect = this.$refs.container.getBoundingClientRect();
                const percent = ( clickedPosition / rect.width ) * 100;
                const newTime = ( this.videoDuration / 100 ) * percent;
                // this.$emit('goToTime', newTime);
                 EventBus.$emit('skipTo', newTime);
            },
        },

        watch:{
            activeVideoId(){
                // when this changes disable the timeline transition so it doesn't slowly move
                // back to the start
                this.skipping = true;
                setTimeout(()=>{
                    this.skipping = false
                },1000);
            }
        }
    }
</script>

<style  lang="scss">
    .timeline-buffered {

    }
    .timeline-container {
        /*background: rgba(0, 0, 0, 0.4);*/
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
         z-index: 5;
        cursor:pointer;
        height: 5px;

        .vue-slider {
            padding: 0 !important;
        }
    }
    .timeline-indicator {

    }
    /*.timeline-played {*/
    /*    position: absolute;*/
    /*    bottom: 0;*/
    /*    left: 0px;*/
    /*    height: 5px;*/
    /*}*/
    .transitioning {
        transition: 1s linear all;
    }
</style>